export default "__VITE_ASSET__Dhgli$ba__"